/**
 * Retrieve the project list data
 *
 * @param  {Object} state
 * @return {Object}
 */
export const projectList = (state) => {
    return state.data
}

/**
 * Determine if the project list has been loaded
 *
 * @param  {Object} state
 * @return {Boolean}
 */
export const hasLoaded = (state) => {
    return state.loaded
}

/**
 * Retrieve the project list meta
 *
 * @param  {Object} state
 * @return {Object}
 */
export const projectMeta = (state) => {
    return state.meta
}

/**
 * Retrieve the entire project list object
 *
 * @param  {Object} state
 * @return {Object}
 */
export const projectData = (state) => {
    return {
        data: state.data,
        meta: state.meta
    }
}

export default {
    hasLoaded,
    projectMeta,
    projectList
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/getters.js